import styles from '../../assets/scss/components/footer/footer.module.scss'
import { Image, Link, useLocalization } from '@shopify/hydrogen'
import { useI18n } from '../i18n.client'
import { EnhancedMenu } from '../../lib/menus'
import { NewsletterForm } from '../newsletter-form.client'
import { LanguageCode } from '@shopify/hydrogen/storefront-api-types'
import { LanguageSwitch } from '../language/language-switch.client'
// import { CurrencySelect } from './currency-select.client'

export const Footer: React.FC<{
  companyMenu: EnhancedMenu
  helpMenu: EnhancedMenu
  isBackgroundWhite: boolean
  legalMenu: EnhancedMenu
  shopMenu: EnhancedMenu
}> = ({ companyMenu, helpMenu, isBackgroundWhite, legalMenu, shopMenu }) => {
  const [i18n] = useI18n()
  const date = new Date()

  return (
    <>
      <footer className={styles.footerContainer}>
        <div className={styles.footer}>
          <div className="section px">
            <div className={styles.grid}>
              {[shopMenu, helpMenu, companyMenu, legalMenu].map((menu) => (
                <Menu key={menu.id} menu={menu} />
              ))}
              <div className={styles.image}>
                <Image alt={i18n.translate('loop-me-in')} height={54} src="/loop-me-in.svg" width={277} />
                <p>{i18n.translate('newsletter-sign-up')}</p>
                <NewsletterForm variant="newsletter_subscription_footer" />
              </div>
            </div>
            {/* <CurrencySelect /> */}
            <div className={styles.smallPrint}>
              <div className={styles.copyright}>
                &copy; Marie Lichtenberg {date.getFullYear()}. {i18n.translate('all-rights-reserved')}
              </div>
              <Link className={styles.credits} to="https://y-wilson.com/" target="_blank">
                {i18n.translate('website-design-and-build-by-y-wilson')}
              </Link>
            </div>
          </div>
        </div>
      </footer>
      <div className={styles.languageSwitch}>
        <LanguageSwitch isWhite={!isBackgroundWhite} />
      </div>
    </>
  )
}

const Menu: React.FC<{ menu: EnhancedMenu }> = ({ menu }) => {
  const {
    language: { isoCode: language },
  } = useLocalization()

  return (
    <div className={styles.menu}>
      <div className={styles.menuTitle}>
        {menu.title === 'Company' && language === LanguageCode.Fr ? 'Marie Lichtenberg' : menu.title}
      </div>
      {menu.items.map(({ id, title, to }) => (
        <Link className={styles.menuLink} key={id} to={to}>
          {title}
        </Link>
      ))}
    </div>
  )
}
